// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.k-drawer-container {
  background: #fff;
}

.edit-time-slot-duration-input {
  padding-top: 7px;
  padding-bottom: 7px;
}

.edit-time-slot-duration-input .k-input-spinner,
.edit-time-slot-duration-input .k-input-spinner .k-button,
.edit-time-slot-duration-input .k-input-spinner .k-button:hover,
.edit-time-slot-duration-input .k-input-spinner .k-button:focus,
.edit-time-slot-duration-input .k-input-spinner .k-button:active {
  background: #fff !important;
  background-color: #fff !important;
}

.edit-time-slot-duration-input .k-input-spinner .k-button {
  border-color: transparent !important;
  color: #525252 !important;
}

/* Compact editor used directly inside the Time View duration column. */
.time-view-duration-input,
.time-view-duration-input .k-input-inner,
.time-view-duration-input .k-input-spinner {
  height: 28px !important;
  min-height: 28px !important;
}

.time-view-duration-input .k-input-inner {
  padding: 2px 4px !important;
  font-size: 14px !important;
  font-weight: 600 !important;
}

.time-view-duration-input .k-input-spinner {
  width: 18px !important;
  min-width: 18px !important;
  border-left: 0 !important;
}

.time-view-duration-input .k-input-spinner .k-button {
  min-height: 13px !important;
  padding: 0 !important;
  border-left: 0 !important;
  border-inline-start-width: 0 !important;
  border-color: transparent !important;
  background: transparent !important;
}

/* 全部禁用状态统一样式 */
.k-input[disabled],
.k-picker-wrap.k-state-disabled,
.k-dropdown-wrap.k-state-disabled,
.k-combobox.k-state-disabled,
.k-dateinput.k-state-disabled,
.k-date-picker.k-state-disabled {
  border-radius: 4px !important;
  border: 1px solid #D9D9D9 !important;
  background: #F9F9F9 !important;
  color: #666 !important;
  opacity: 1 !important; /* 取消默认的灰显 */
  cursor: not-allowed !important;
}

/* 输入框内部文字也统一颜色 */
.k-input.k-disabled input,
.k-picker-wrap.k-state-disabled input,
.k-dropdown-wrap.k-state-disabled input {
  background: #F9F9F9 !important;
  color: #666 !important;
}

/* 让 Grid 内容容器成为定位上下文 */
.k-grid-content {
  position: relative;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE/Edge legacy */
}

.k-grid-content::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
}

/* 使 NoRecords 内容绝对定位在 Grid 内容区中 */
.by-matter-grid .k-grid-norecords {
  position: absolute !important;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%); /* 精准居中 */
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  pointer-events: none; /* 防止挡住其他交互区域 */
}

.by-matter-grid .k-grid-norecords .no-record-title {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
}

.by-matter-grid .k-grid-norecords .no-record-desc {
  color: #999;
  font-size: 12px;
  width: 40vw;
  margin: 20px 0 auto;
}

.no-record-image {
  max-width: 200px;      /* 控制最大宽度 */
  width: 30%;            /* 相对于容器宽度 */
  height: auto;          /* 保持原始比例 */
  -o-object-fit: contain;
     object-fit: contain;   /* 保证图像不变形 */
}

.k-drawer-wrapper {
  width: 300px !important; /* 手机端时可以用 media query */
}


.k-chip-solid-base {
  color: #333;
  font-size: 16px;
  font-weight: 600;
  border-radius: 6px!important;
  border: 1px solid #E0DEDD !important;
  background: #F2F4FF !important;
}

@media (min-width: 768px) {
  .k-drawer-wrapper {
    width: 240px !important; /* PC端 */
  }
}

.custom-open-switch .k-switch-track {
  border-color: #B094EA;
  background-color: #B094EA;
}

/* Narrative preference checkboxes: unchecked = gray border + white bg, checked = brand purple */
.narrative-preference .k-checkbox {
  border-radius: 4px !important;
  border: 1px solid #757575 !important;
}

.narrative-preference .k-checkbox:focus,
.narrative-preference .k-checkbox.k-focus {
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.narrative-preference .k-checkbox:checked,
.narrative-preference .k-checkbox:indeterminate,
.narrative-preference .k-checkbox.k-checked,
.narrative-preference .k-checkbox.k-indeterminate {
  background-color: #865bdf !important;
  border: 1px solid #865bdf !important;
}

/* Disabled switch: no border */
.narrative-preference .k-switch.k-disabled .k-switch-track,
.narrative-preference .k-switch:disabled .k-switch-track {
  border-color: transparent !important;
}

/* Kendo's .k-checkbox-wrap defaults to align-self: flex-start, which breaks vertical centering */
.narrative-preference .k-checkbox-wrap {
  -ms-flex-item-align: center;
      align-self: center;
}

/* 空状态：内部 label */
.k-floating-label-container {
  display: block !important;
  width: 100% !important;
  padding-top: 20px;
}

.k-floating-label-container.k-state-empty label {
  color: #958EA4;        /* 内部灰色 */
  font-size: 14px;
  font-weight: 400;
}

/* 聚焦状态 */
.k-floating-label-container.k-state-focused label {
  color: #6E687C;     /* 聚焦时颜色 */
  font-size: 12px;
  font-weight: 400;
}

/* 有值但不聚焦 */
.valid-label {
  color: #6E687C!important;     /* 聚焦时颜色 */
  font-size: 12px!important;
  font-weight: 400!important;
}

.k-text-error, .k-color-error {
  color: #B3261E;
}

.form-error-border {
  border: 1px solid #B3261E;
}

/* .k-floating-label-container.k-state-focused .search-combobox{
    border: 2px solid #AC58FF;
}
.k-floating-label-container.k-state-focused .k-textarea{
    border: 2px solid #AC58FF;
} */
.k-floating-label-container.k-state-focused .k-input{
    border: 2px solid #AC58FF;
}

.form-error .search-combobox {
    border: 1px solid #B3261E;
}

.form-error .k-textarea {
       border: 1px solid #B3261E;
}

.focus-error-border {
  border: 2px solid #B3261E;
}

.focus-border {
  border: 2px solid #AC58FF;
}

.k-listview-content {
  overflow-x: hidden;
  padding: 0 28px;
}

.search-combobox .k-button-solid-base {
    background: #fff;
    border: none;
}

.custom-time-picker .k-button-solid-base {
    background: #fff;
    border: none;
}

.time-picker-with-enter .k-button-solid-base {
    background: #fff;
    border-left: 0px;
}

.custom-floating-label .k-button-solid-base {
    background: #fff;
    border: none;
}

/* 阻止 FloatingLabel 在 focus 时浮动 */
.custom-floating-label .k-label {
  display: none;
}

/* 有值时显示 */
.custom-floating-label.k-state-empty .k-label {
  display: inline-block;
  -webkit-transform: translateY(-20px);
          transform: translateY(-20px);
}

.custom-floating-label:focus-within > .k-label{
  display: none;
}

.custom-floating-label {
  padding-top: 0;
}


.by-matter-grid .k-grid tr.custom-row.row-focus {
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.by-matter-grid .k-grid tr.custom-row.group-focus {
  -webkit-box-shadow:
    inset 1px 0 0 0 #865BDF,
    inset -1px 0 0 0 #865BDF !important;
          box-shadow:
    inset 1px 0 0 0 #865BDF,
    inset -1px 0 0 0 #865BDF !important;
}

.by-matter-grid .group-focus td:first-child::before,
.by-matter-grid .group-focus td:last-child::after {
  background: #865BDF !important;
}

.gridPage .by-matter-grid .k-grid tr.custom-row.group-focus {
  -webkit-box-shadow: none !important;
          box-shadow: none !important;
}

.gridPage .by-matter-grid .group-focus td:first-child::before,
.gridPage .by-matter-grid .group-focus td:last-child::after {
  display: none !important;
}

.by-matter-grid .k-grid .k-table-td.k-focus,
.by-matter-grid .k-grid td.k-focus,
.by-matter-grid .k-grid td:focus {
  outline: none !important;
  -webkit-box-shadow: inset 0 0 0 1px #865BDF !important;
          box-shadow: inset 0 0 0 1px #865BDF !important;
}

.by-matter-grid .k-grid textarea:focus {
  border-color: #865BDF !important;
  outline: none !important;
  -webkit-box-shadow: 0 0 0 1px #865BDF !important;
          box-shadow: 0 0 0 1px #865BDF !important;
}

.by-matter-grid .k-grid tr.custom-row > td:first-child {
  border-left: 1px solid #D9D9D9;
}

.by-matter-grid .k-grid tr.custom-row > td:last-child {
  border-right: 1px solid #D9D9D9;
}

.by-matter-grid .k-grid tr.custom-row-last > td {
  border-bottom: 1px solid #D9D9D9 !important;
}

.by-matter-grid .k-grid tr.custom-row-last > td:first-child {
  border-radius: 0 0 0 10px;
  overflow: hidden;
}

.by-matter-grid .k-grid tr.custom-row-last > td:last-child {
  border-radius: 0 0 10px 0;
  overflow: hidden;
}

.by-matter-grid .k-grid tr.group-border-last > td {
  height: 0 !important;
  background: transparent !important;
}

.by-matter-grid .group-header {
  width: 100%;
  overflow: hidden;
}

.by-matter-grid .k-grid-table {
  border-collapse: separate;
  border-spacing: 0;
}

.by-matter-grid .k-grid tr.group-row > td {
  width: 100%;
}

.by-matter-grid .k-grid tr.group-row .group-header {
  min-width: 100%;
  max-width: 100%;
}

.by-matter-grid .k-grid tr.custom-row-last > td:first-child:last-child {
  border-radius: 0 0 10px 10px;
}

.by-matter-grid .k-grid tr.custom-row.timeline-drop-target {
  background-color: #e8e8e8 !important;
  -webkit-box-shadow: inset 0 0 0 2px #555 !important;
          box-shadow: inset 0 0 0 2px #555 !important;
}

.by-matter-grid .k-grid tr.custom-row.timeline-drop-blocked {
  background-color: #fff4f4 !important;
  -webkit-box-shadow: inset 0 0 0 2px #e87973 !important;
          box-shadow: inset 0 0 0 2px #e87973 !important;
  cursor: not-allowed !important;
}

.gridRowLoader .k-loader-primary {
  color: #865BDF;
  z-index: 2;
  left: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/css/kendo-overrides.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;;EAKE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA,uEAAuE;AACvE;;;EAGE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,yBAAyB;EACzB,uCAAuC;EACvC,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA,eAAe;AACf;;;;;;EAME,6BAA6B;EAC7B,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;EACtB,qBAAqB,EAAE,YAAY;EACnC,8BAA8B;AAChC;;AAEA,iBAAiB;AACjB;;;EAGE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,mBAAmB;AAC/C;;AAEA;IACI,aAAa,EAAE,kBAAkB;AACrC;;AAEA,kCAAkC;AAClC;EACE,6BAA6B;EAC7B,QAAQ;EACR,wCAAgC;UAAhC,gCAAgC,EAAE,SAAS;EAC3C,WAAW;EACX,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,oBAAoB,EAAE,eAAe;AACvC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB,OAAO,WAAW;EAClC,UAAU,aAAa,YAAY;EACnC,YAAY,WAAW,WAAW;EAClC,sBAAmB;KAAnB,mBAAmB,IAAI,YAAY;AACrC;;AAEA;EACE,uBAAuB,EAAE,wBAAwB;AACnD;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE;IACE,uBAAuB,EAAE,QAAQ;EACnC;AACF;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,gGAAgG;AAChG;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;;EAEE,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;;;;EAIE,oCAAoC;EACpC,oCAAoC;AACtC;;AAEA,+BAA+B;AAC/B;;EAEE,oCAAoC;AACtC;;AAEA,iGAAiG;AACjG;EACE,2BAAkB;MAAlB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,cAAc,SAAS,SAAS;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,cAAc,MAAM,UAAU;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,wBAAwB,MAAM,UAAU;EACxC,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;GAKG;AACH;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;OACO,yBAAyB;AAChC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;AACf;;AAEA,UAAU;AACV;EACE,qBAAqB;EACrB,oCAA4B;UAA5B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE;;uCAEqC;UAFrC;;uCAEqC;AACvC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;;EAGE,wBAAwB;EACxB,sDAA8C;UAA9C,8CAA8C;AAChD;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,gDAAwC;UAAxC,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,mDAA2C;UAA3C,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,sDAA8C;UAA9C,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,UAAU;AACZ","sourcesContent":[".k-drawer-container {\n  background: #fff;\n}\n\n.edit-time-slot-duration-input {\n  padding-top: 7px;\n  padding-bottom: 7px;\n}\n\n.edit-time-slot-duration-input .k-input-spinner,\n.edit-time-slot-duration-input .k-input-spinner .k-button,\n.edit-time-slot-duration-input .k-input-spinner .k-button:hover,\n.edit-time-slot-duration-input .k-input-spinner .k-button:focus,\n.edit-time-slot-duration-input .k-input-spinner .k-button:active {\n  background: #fff !important;\n  background-color: #fff !important;\n}\n\n.edit-time-slot-duration-input .k-input-spinner .k-button {\n  border-color: transparent !important;\n  color: #525252 !important;\n}\n\n/* Compact editor used directly inside the Time View duration column. */\n.time-view-duration-input,\n.time-view-duration-input .k-input-inner,\n.time-view-duration-input .k-input-spinner {\n  height: 28px !important;\n  min-height: 28px !important;\n}\n\n.time-view-duration-input .k-input-inner {\n  padding: 2px 4px !important;\n  font-size: 14px !important;\n  font-weight: 600 !important;\n}\n\n.time-view-duration-input .k-input-spinner {\n  width: 18px !important;\n  min-width: 18px !important;\n  border-left: 0 !important;\n}\n\n.time-view-duration-input .k-input-spinner .k-button {\n  min-height: 13px !important;\n  padding: 0 !important;\n  border-left: 0 !important;\n  border-inline-start-width: 0 !important;\n  border-color: transparent !important;\n  background: transparent !important;\n}\n\n/* 全部禁用状态统一样式 */\n.k-input[disabled],\n.k-picker-wrap.k-state-disabled,\n.k-dropdown-wrap.k-state-disabled,\n.k-combobox.k-state-disabled,\n.k-dateinput.k-state-disabled,\n.k-date-picker.k-state-disabled {\n  border-radius: 4px !important;\n  border: 1px solid #D9D9D9 !important;\n  background: #F9F9F9 !important;\n  color: #666 !important;\n  opacity: 1 !important; /* 取消默认的灰显 */\n  cursor: not-allowed !important;\n}\n\n/* 输入框内部文字也统一颜色 */\n.k-input.k-disabled input,\n.k-picker-wrap.k-state-disabled input,\n.k-dropdown-wrap.k-state-disabled input {\n  background: #F9F9F9 !important;\n  color: #666 !important;\n}\n\n/* 让 Grid 内容容器成为定位上下文 */\n.k-grid-content {\n  position: relative;\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE/Edge legacy */\n}\n\n.k-grid-content::-webkit-scrollbar {\n    display: none; /* Chrome/Safari */\n}\n\n/* 使 NoRecords 内容绝对定位在 Grid 内容区中 */\n.by-matter-grid .k-grid-norecords {\n  position: absolute !important;\n  top: 50%;\n  transform: translate(-50%, -50%); /* 精准居中 */\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none; /* 防止挡住其他交互区域 */\n}\n\n.by-matter-grid .k-grid-norecords .no-record-title {\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n  margin-bottom: 20px;\n}\n\n.by-matter-grid .k-grid-norecords .no-record-desc {\n  color: #999;\n  font-size: 12px;\n  width: 40vw;\n  margin: 20px 0 auto;\n}\n\n.no-record-image {\n  max-width: 200px;      /* 控制最大宽度 */\n  width: 30%;            /* 相对于容器宽度 */\n  height: auto;          /* 保持原始比例 */\n  object-fit: contain;   /* 保证图像不变形 */\n}\n\n.k-drawer-wrapper {\n  width: 300px !important; /* 手机端时可以用 media query */\n}\n\n\n.k-chip-solid-base {\n  color: #333;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 6px!important;\n  border: 1px solid #E0DEDD !important;\n  background: #F2F4FF !important;\n}\n\n@media (min-width: 768px) {\n  .k-drawer-wrapper {\n    width: 240px !important; /* PC端 */\n  }\n}\n\n.custom-open-switch .k-switch-track {\n  border-color: #B094EA;\n  background-color: #B094EA;\n}\n\n/* Narrative preference checkboxes: unchecked = gray border + white bg, checked = brand purple */\n.narrative-preference .k-checkbox {\n  border-radius: 4px !important;\n  border: 1px solid #757575 !important;\n}\n\n.narrative-preference .k-checkbox:focus,\n.narrative-preference .k-checkbox.k-focus {\n  box-shadow: none !important;\n}\n\n.narrative-preference .k-checkbox:checked,\n.narrative-preference .k-checkbox:indeterminate,\n.narrative-preference .k-checkbox.k-checked,\n.narrative-preference .k-checkbox.k-indeterminate {\n  background-color: #865bdf !important;\n  border: 1px solid #865bdf !important;\n}\n\n/* Disabled switch: no border */\n.narrative-preference .k-switch.k-disabled .k-switch-track,\n.narrative-preference .k-switch:disabled .k-switch-track {\n  border-color: transparent !important;\n}\n\n/* Kendo's .k-checkbox-wrap defaults to align-self: flex-start, which breaks vertical centering */\n.narrative-preference .k-checkbox-wrap {\n  align-self: center;\n}\n\n/* 空状态：内部 label */\n.k-floating-label-container {\n  display: block !important;\n  width: 100% !important;\n  padding-top: 20px;\n}\n\n.k-floating-label-container.k-state-empty label {\n  color: #958EA4;        /* 内部灰色 */\n  font-size: 14px;\n  font-weight: 400;\n}\n\n/* 聚焦状态 */\n.k-floating-label-container.k-state-focused label {\n  color: #6E687C;     /* 聚焦时颜色 */\n  font-size: 12px;\n  font-weight: 400;\n}\n\n/* 有值但不聚焦 */\n.valid-label {\n  color: #6E687C!important;     /* 聚焦时颜色 */\n  font-size: 12px!important;\n  font-weight: 400!important;\n}\n\n.k-text-error, .k-color-error {\n  color: #B3261E;\n}\n\n.form-error-border {\n  border: 1px solid #B3261E;\n}\n\n/* .k-floating-label-container.k-state-focused .search-combobox{\n    border: 2px solid #AC58FF;\n}\n.k-floating-label-container.k-state-focused .k-textarea{\n    border: 2px solid #AC58FF;\n} */\n.k-floating-label-container.k-state-focused .k-input{\n    border: 2px solid #AC58FF;\n}\n\n.form-error .search-combobox {\n    border: 1px solid #B3261E;\n}\n\n.form-error .k-textarea {\n       border: 1px solid #B3261E;\n}\n\n.focus-error-border {\n  border: 2px solid #B3261E;\n}\n\n.focus-border {\n  border: 2px solid #AC58FF;\n}\n\n.k-listview-content {\n  overflow-x: hidden;\n  padding: 0 28px;\n}\n\n.search-combobox .k-button-solid-base {\n    background: #fff;\n    border: none;\n}\n\n.custom-time-picker .k-button-solid-base {\n    background: #fff;\n    border: none;\n}\n\n.time-picker-with-enter .k-button-solid-base {\n    background: #fff;\n    border-left: 0px;\n}\n\n.custom-floating-label .k-button-solid-base {\n    background: #fff;\n    border: none;\n}\n\n/* 阻止 FloatingLabel 在 focus 时浮动 */\n.custom-floating-label .k-label {\n  display: none;\n}\n\n/* 有值时显示 */\n.custom-floating-label.k-state-empty .k-label {\n  display: inline-block;\n  transform: translateY(-20px);\n}\n\n.custom-floating-label:focus-within > .k-label{\n  display: none;\n}\n\n.custom-floating-label {\n  padding-top: 0;\n}\n\n\n.by-matter-grid .k-grid tr.custom-row.row-focus {\n  box-shadow: none !important;\n}\n\n.by-matter-grid .k-grid tr.custom-row.group-focus {\n  box-shadow:\n    inset 1px 0 0 0 #865BDF,\n    inset -1px 0 0 0 #865BDF !important;\n}\n\n.by-matter-grid .group-focus td:first-child::before,\n.by-matter-grid .group-focus td:last-child::after {\n  background: #865BDF !important;\n}\n\n.gridPage .by-matter-grid .k-grid tr.custom-row.group-focus {\n  box-shadow: none !important;\n}\n\n.gridPage .by-matter-grid .group-focus td:first-child::before,\n.gridPage .by-matter-grid .group-focus td:last-child::after {\n  display: none !important;\n}\n\n.by-matter-grid .k-grid .k-table-td.k-focus,\n.by-matter-grid .k-grid td.k-focus,\n.by-matter-grid .k-grid td:focus {\n  outline: none !important;\n  box-shadow: inset 0 0 0 1px #865BDF !important;\n}\n\n.by-matter-grid .k-grid textarea:focus {\n  border-color: #865BDF !important;\n  outline: none !important;\n  box-shadow: 0 0 0 1px #865BDF !important;\n}\n\n.by-matter-grid .k-grid tr.custom-row > td:first-child {\n  border-left: 1px solid #D9D9D9;\n}\n\n.by-matter-grid .k-grid tr.custom-row > td:last-child {\n  border-right: 1px solid #D9D9D9;\n}\n\n.by-matter-grid .k-grid tr.custom-row-last > td {\n  border-bottom: 1px solid #D9D9D9 !important;\n}\n\n.by-matter-grid .k-grid tr.custom-row-last > td:first-child {\n  border-radius: 0 0 0 10px;\n  overflow: hidden;\n}\n\n.by-matter-grid .k-grid tr.custom-row-last > td:last-child {\n  border-radius: 0 0 10px 0;\n  overflow: hidden;\n}\n\n.by-matter-grid .k-grid tr.group-border-last > td {\n  height: 0 !important;\n  background: transparent !important;\n}\n\n.by-matter-grid .group-header {\n  width: 100%;\n  overflow: hidden;\n}\n\n.by-matter-grid .k-grid-table {\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\n.by-matter-grid .k-grid tr.group-row > td {\n  width: 100%;\n}\n\n.by-matter-grid .k-grid tr.group-row .group-header {\n  min-width: 100%;\n  max-width: 100%;\n}\n\n.by-matter-grid .k-grid tr.custom-row-last > td:first-child:last-child {\n  border-radius: 0 0 10px 10px;\n}\n\n.by-matter-grid .k-grid tr.custom-row.timeline-drop-target {\n  background-color: #e8e8e8 !important;\n  box-shadow: inset 0 0 0 2px #555 !important;\n}\n\n.by-matter-grid .k-grid tr.custom-row.timeline-drop-blocked {\n  background-color: #fff4f4 !important;\n  box-shadow: inset 0 0 0 2px #e87973 !important;\n  cursor: not-allowed !important;\n}\n\n.gridRowLoader .k-loader-primary {\n  color: #865BDF;\n  z-index: 2;\n  left: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
